module.exports = __webpack_public_path__ + "static/media/ImgDr.f5bbcd6a.webp";